import { Component } from '@angular/core';
import { BaseComponent } from '../../components/base.component';

@Component({
  selector: 'app-permission',
  templateUrl: './permission.component.html',
  styleUrls: ['./permission.component.scss']
})
export class PermissionComponent extends BaseComponent {
  constructor() {
    super();
  }
}
